var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgQuote = function SvgQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.633 0c1.576 0 2.856.138 3.841.413l-.473 9.027c-4.728.629-7.466 3.736-8.215 9.321H25L24.175 40H0l.236-19.41C.355 12.606 3.842 6.726 10.698 2.95 14.284.983 17.928 0 21.632 0zm30.775 0c1.576 0 2.857.138 3.842.413l-.473 9.027c-4.728.629-7.467 3.736-8.215 9.321h8.215L54.95 40H30.776l.236-19.41c.118-7.984 3.605-13.864 10.462-17.64C45.059.983 48.704 0 52.408 0z",
    fill: "#FF0051"
  })));
};
export default SvgQuote;